import React from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  TimePicker,
  Radio,
  Checkbox,
  Switch,
  InputNumber,
  Upload,
  Rate,
  Slider,
  Row,
  Col,
  Space,
  Divider,
  Typography,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { PageContainer, StyledCard } from '../../../styles/common';

const { Option } = Select;
const { TextArea } = Input;
const { Title } = Typography;

const FormElements: React.FC = () => {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log('Form values:', values);
  };

  return (
    <PageContainer>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ maxWidth: 800 }}
        >
          <Row gutter={[24, 0]}>
            <Col span={24}>
              <StyledCard>
                <Title level={5}>Text Inputs</Title>
                <Row gutter={[24, 24]}>
                  <Col span={12}>
                    <Form.Item
                      label="Text Input"
                      name="textInput"
                      rules={[{ required: true, message: 'Please input some text!' }]}
                    >
                      <Input size="large" placeholder="large size" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Password"
                      name="password"
                      rules={[{ required: true, message: 'Please input your password!' }]}
                    >
                      <Input.Password placeholder="Enter password" size="middle" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="Text Area"
                      name="textArea"
                    >
                      <TextArea rows={4} placeholder="Enter multiple lines of text" />
                    </Form.Item>
                  </Col>
                </Row>
              </StyledCard>
            </Col>

            <Col span={24} style={{ marginTop: 24 }}>
              <StyledCard>
                <Title level={5}>Selection Elements</Title>
                <Row gutter={[24, 24]}>
                  <Col span={12}>
                    <Form.Item
                      label="Select"
                      name="select"
                    >
                      <Select placeholder="Select an option">
                        <Option value="option1">Option 1</Option>
                        <Option value="option2">Option 2</Option>
                        <Option value="option3">Option 3</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Multiple Select"
                      name="multiSelect"
                    >
                      <Select
                        mode="multiple"
                        placeholder="Select multiple options"
                      >
                        <Option value="option1">Option 1</Option>
                        <Option value="option2">Option 2</Option>
                        <Option value="option3">Option 3</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </StyledCard>
            </Col>

            <Col span={24} style={{ marginTop: 24 }}>
              <StyledCard>
                <Title level={5}>Date & Time</Title>
                <Row gutter={[24, 24]}>
                  <Col span={12}>
                    <Form.Item
                      label="Date Picker"
                      name="datePicker"
                    >
                      <DatePicker style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Time Picker"
                      name="timePicker"
                    >
                      <TimePicker style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                </Row>
              </StyledCard>
            </Col>

            <Col span={24} style={{ marginTop: 24 }}>
              <StyledCard>
                <Title level={5}>Other Form Elements</Title>
                <Row gutter={[24, 24]}>
                  <Col span={12}>
                    <Form.Item
                      label="Radio Group"
                      name="radioGroup"
                    >
                      <Radio.Group>
                        <Radio value="a">Option A</Radio>
                        <Radio value="b">Option B</Radio>
                        <Radio value="c">Option C</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Checkbox Group"
                      name="checkboxGroup"
                    >
                      <Checkbox.Group>
                        <Row>
                          <Col span={8}>
                            <Checkbox value="A">A</Checkbox>
                          </Col>
                          <Col span={8}>
                            <Checkbox value="B">B</Checkbox>
                          </Col>
                          <Col span={8}>
                            <Checkbox value="C">C</Checkbox>
                          </Col>
                        </Row>
                      </Checkbox.Group>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Switch"
                      name="switch"
                      valuePropName="checked"
                    >
                      <Switch />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Number Input"
                      name="numberInput"
                    >
                      <InputNumber style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Rate"
                      name="rate"
                    >
                      <Rate />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Slider"
                      name="slider"
                    >
                      <Slider />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Upload"
                      name="upload"
                    >
                      <Upload>
                        <Button icon={<UploadOutlined />}>Click to Upload</Button>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
              </StyledCard>
            </Col>

            <Col span={24} style={{ marginTop: 24 }}>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Submit Form
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Space>
    </PageContainer>
  );
};

export default FormElements;
